import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import { api, conferenceLabel, type Booking, type Me } from '../api';
import { ErrorBox, Loading } from '../components/bk';
import { HOST_TZ, tzName } from '../components/TimezoneSelect';

export function Bookings() {
  const me = useOutletContext<Me | null>();
  const [list, setList] = useState<Booking[] | null>(null);
  const [showPast, setShowPast] = useState(false);
  const [error, setError] = useState('');
  const tz = me?.timezone ?? HOST_TZ;

  useEffect(() => {
    setList(null);
    const from = showPast ? DateTime.now().minus({ days: 60 }) : DateTime.now().minus({ hours: 2 });
    api
      .get<Booking[]>(`/api/bookings?status=all&from=${from.toUTC().toISO()}`)
      .then((l) => setList(showPast ? [...l].reverse() : l))
      .catch((e) => setError(e.message));
  }, [showPast]);

  const groups = new Map<string, Booking[]>();
  for (const b of list ?? []) {
    const k = DateTime.fromISO(b.start).setZone(tz).toFormat('cccc, LLLL d');
    groups.set(k, [...(groups.get(k) ?? []), b]);
  }

  return (
    <>
      <div className="pagehead">
        <div>
          <h1>Meetings</h1>
          <p className="muted">Bookings where you are a host. Times shown in {tzName(tz)}.</p>
        </div>
        <label className="check"><input type="checkbox" checked={showPast} onChange={(e) => setShowPast(e.target.checked)} /> Include past</label>
      </div>
      <ErrorBox error={error} />
      {!list ? (
        <Loading />
      ) : !list.length ? (
        <div className="card empty">No meetings booked yet.</div>
      ) : (
        [...groups].map(([day, items]) => (
          <section className="card" key={day}>
            <h3>{day}</h3>
            <ul className="list">
              {items.map((b) => (
                <li key={b.id}>
                  <Link to={`/bookings/${b.id}`} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
                    <div className="row between">
                      <span className="when">
                        {DateTime.fromISO(b.start).setZone(tz).toFormat('h:mm a')} – {DateTime.fromISO(b.end).setZone(tz).toFormat('h:mm a ZZZZ')}
                      </span>
                      {b.status === 'canceled' ? <span className="badge err">Canceled</span> : <span className="badge">{conferenceLabel[b.conference.type]}</span>}
                    </div>
                    <div>{b.inviteeName} <span className="muted small">· {b.linkTitle}</span></div>
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ))
      )}
    </>
  );
}
